const CloseButton = ({ onClose }) => (
  <button className="btn-close" onClick={() => onClose()}>
    X
  </button>
);

export default CloseButton;
